//http://wx.hztywl.cn/bzb/h5.html?#/map/navigation
// http://localhost:8080/h5.html?#/map/navigation

// http://localhost:8080/h5.html?#/map/navigation?lat=30.105224&lng=120.253742
// http://wx.hztywl.cn/bzb/h5.html?#/map/navigation?lat=30.105224&lng=120.253742


export default [
  //网约护士医生端查看导航
  {
    path: '/map/navigation',
    meta: {
      title: '地图导航'
    },
    component: () => import('../pages/map/map-navigation')
  },
]



// WEBPACK FOOTER //
// ./h5/router/map.js